import { Collection } from '@msw/data'
import { apiConfigurationSchema } from 'app/src/msw/companyagreement/schemas/apiConfigurationSchema'

const ApiConfigurationCollection = new Collection({
  schema: apiConfigurationSchema,
  // extensions: [persist()],
})

export { ApiConfigurationCollection }

export const createApiConfigurationSeed = async () => {
  const existingData = await ApiConfigurationCollection.findMany()

  if (existingData.length > 0) {
    return
  }

  const jsonData = await (await fetch('data/companyagreement/apiConfiguration/apiConfiguration.json')).json()

  const createdConfigurations = await ApiConfigurationCollection.create(jsonData)

  console.log('createdConfigurations', createdConfigurations)
}
